// 页头往下滚后加 .is-glass。吸顶状态由主题 header.js 写在 data-sticky-state 上,这里只跟随它,不另做滚动判断。
(function () {
  function bind() {
    var header = document.getElementById('header-component');
    if (!header || header.__wbGlass) return;
    header.__wbGlass = true;
    function sync() { header.classList.toggle('is-glass', header.dataset.stickyState === 'active'); }
    new MutationObserver(sync).observe(header, { attributes: true, attributeFilter: ['data-sticky-state'] });
    sync();
  }
  // 桌面下拉的小图不写 src,地址只放在 data-wb-src 里。主题 header-menu.js 在页面加载完后会把页头里所有
  // loading="lazy" 的图改成立即加载,不分屏幕宽度,手机也会下载这 7 张;没有 src 的图它选不中,也不会被下载。
  // 这里只在桌面宽度(≥750px,下拉菜单出现的宽度)把地址填上:浏览器空闲时,或鼠标、键盘焦点进入页头时,先到先算。
  // 7 张共约 25KB。不等 load 事件:首页有视频,load 实测要十几秒。
  var desktop = window.matchMedia ? matchMedia('(min-width: 750px)') : null;
  function loadThumbs() {
    if (!desktop || !desktop.matches) return;
    document.querySelectorAll('.wb-mega__thumb img[data-wb-src]').forEach(function (img) {
      img.src = img.getAttribute('data-wb-src');
      img.removeAttribute('data-wb-src');
    });
  }
  function onHeader(e) {
    if (e.target.closest && e.target.closest('#header-component')) loadThumbs();
  }

  bind();
  if (window.requestIdleCallback) requestIdleCallback(loadThumbs, { timeout: 3000 });
  else setTimeout(loadThumbs, 1500);
  document.addEventListener('pointerover', onHeader, { passive: true });
  document.addEventListener('focusin', onHeader);
  // 手机横过来或窗口拉宽到桌面宽度时补上
  if (desktop && desktop.addEventListener) desktop.addEventListener('change', loadThumbs);
  // 主题在页面加载后会重新取一次页头 HTML,按 data-hydration-key 合并进页面(section-hydration.js),
  // 合并时把小图改回服务器下发的样子(只有 data-wb-src、没有 src),正在下载的图也被中止。
  // 合并完成后主题在版块外层写上 data-hydrated="true",看到它就再填一次。
  var section = document.getElementById('header-component');
  section = section && section.closest('.shopify-section');
  if (section && section.dataset.hydrated !== 'true' && window.MutationObserver) {
    var hydration = new MutationObserver(function () {
      if (section.dataset.hydrated !== 'true') return;
      hydration.disconnect();
      loadThumbs();
    });
    hydration.observe(section, { attributes: true, attributeFilter: ['data-hydrated'] });
  }
  // 主题编辑器里重新渲染页头会换掉节点
  document.addEventListener('shopify:section:load', function () { bind(); loadThumbs(); });
})();
